<template>
  <div class="main">
    <ms-login v-if="this.url === '/login'"></ms-login>
    <el-container class="nav-container" v-else>
      <!-- <el-header class="header">
        <ms-nav></ms-nav>
      </el-header> -->
      <el-main class="main">
        <router-view></router-view>
      </el-main>
      <el-footer class="footer" v-if="showQuDao">
        <ms-footer @click="backTop"></ms-footer>
      </el-footer>
      <!--<div class="back-top">
        <div @mouseenter="show()"  @mouseout="hide()" @click="open">
          <img @mouseout="hide()" src="../../../assets/images/icon_form.png" v-show="!isShow"/>
          <span @mouseenter="show()" v-show="isShow">大数据营销定制</span>
        </div>
        <div class="qrcode" @mouseenter="showFlag()"  @mouseout="hideFlag()">
          <div class="img" v-show="flag"><img @mouseout="hideFlag()" src="../../../assets/images/xcx.jpg"/></div>
          <span @mouseenter="showFlag()" style="padding-top: 10px;box-sizing:border-box">微信小程序</span>
        </div>
        <div @mouseenter="showMsg()"  @mouseout="hideMsg()">
          <img @mouseout="hideMsg()" src="../../../assets/images/icon_service.png" v-show="!msg"/>
          <span @click="dialogVisible=true" @mouseenter="showMsg()" style="padding-top: 10px;box-sizing:border-box"
                v-show="msg">在线咨询</span>
        </div>
      </div>
      -->
      <el-dialog
        class="dia-title"
        title="填写信息让您的专属客服帮您"
        :visible.sync="dialogVisible"
        center
        width="690px"
        height="460px">
        <div class="message">
          <el-form :model="form" ref="formModifyRow" :rules="rules">
            <el-form-item :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
              <el-input
                v-model="form.enterpriseName"
                placeholder="企业名称（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
              <el-input
                v-model="form.name"
                placeholder="姓名（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确'}]">
              <el-input
                v-model="form.telephone"
                placeholder="联系电话（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <DeliveryStrategy ref="DeliveryStrategy" :platform="3" :type="1"></DeliveryStrategy>
    </el-container>
  </div>
</template>
<script>
  import MsNav from '@/components/tourist/common/Nav'
  import MsFooter from '@/components/tourist/common/Footer'
  import Api from '@/api/customer-good'
  import { FormArgument } from '@/models/customer-good'
  import DeliveryStrategy from '@/components/tourist/common/DeliveryStrategy'
  import MsLogin from '@/components/Login'
  export default {
    name: 'ms-tourist-container',
    components: {
      MsNav,
      MsFooter,
      MsLogin,
      DeliveryStrategy
    },
    data () {
      return {
        btnFlag: false,
        isShow: false,
        flag: false,
        msg: false,
        message: [],
        form: new FormArgument(),
        dialogVisible: false,
        fullWidth: document.documentElement.clientWidth + 'px',
        url: '',
        showQuDao: true
      }
    },
    watch: {
      $route (to, from) {
        this.url = this.$route.path
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
    },
    mounted () {
      this.url = this.$route.path
      window.addEventListener('scroll', this.scrollToTop)
    },
    methods: {
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      },
      showFlag () {
        this.flag = true
      },
      hideFlag () {
        this.flag = false
      },
      showMsg () {
        this.msg = true
      },
      hideMsg () {
        this.msg = false
      },
      // 点击图片回到顶部方法，加计时器是为了过渡顺滑
      backTop () {
        let that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
      },
      // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
      scrollToTop () {
        let that = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        that.scrollTop = scrollTop
        if (that.scrollTop > 180) {
          that.btnFlag = true
        } else {
          that.btnFlag = false
        }
      },
      submitRow () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            let form = this.form
            form.type = 4
            form.platform = 1
            if (this.$store.state.user.info !== null) {
              Api.createLogin({form: form}, response => {
                let status = response.data.code
                let body = response.data
                if (status === '200') {
                  // 新数据加到数组开头
                  this.message.unshift(body.data)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.msg || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialogVisible = false
            } else {
              Api.create({form: form}, response => {
                let status = response.data.code
                let body = response.data
                if (status === '200') {
                  // 新数据加到数组开头
                  this.message.unshift(body.data)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.msg || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialogVisible = false
            }
          } else {
            return false
          }
          this.form = []
        })
      },
      open () {
        this.$refs['DeliveryStrategy'].open()
      }
    }
  }
</script>
<style scoped="scoped" lang="scss">
  .qrcode{
    position: relative;
    .img{
      width:150px;
      height:150px;
      background:rgba(255,255,255,1);
      box-shadow:3px 9px 10px 0px rgba(15,15,15,0.15);
      position: absolute;
      top:-20px;
      left:-160px;
      padding:4px;
      box-sizing: border-box;
      border-radius: 5px;
      &::after{
        content:'';
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 0 solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid #fff;
        position: absolute;
        right:-8px;
        top:40px;
      }
      img{
        width:100%;
      }
    }
  }
  @media screen and (min-height: 1300px) {
    .back-top {
      position: fixed;
      right: 20px;
      top: 80px;
      z-index: 999;
    }
  }
  .main{
    width: 100%;
    .nav-container{
      width: 100%;
      /*position: relative;*/
      .header{
        height:102px !important;
        padding: 0;
        margin: 0 auto;
      }
      .main{
        padding: 0;
        margin: 0;
        // overflow: visible;
      }
      .footer{
        padding: 0;
        margin: 0;
        border-top: 1px solid #eee;
      }
      .dia-title{
        .message {
          padding: 45px 130px;
          box-sizing: border-box;
          .message-inp {
            width: 380px;
            height: 40px;
          }
          .message-btn {
            width: 180px !important;
            height: 40px !important;
            margin-left: 28%;
            background: #085ECC;
            &:hover{
              background: #4a98ff;
              transition-duration: 0.5s;
            }
          }
        }
      }
      .back-top{
        position: fixed;
        right: 20px;
        bottom: 80px;
        z-index: 999;
        >div{
          width: 66px;
          height: 66px;
          background: #085ECC;
          margin-top: 26px;
          position: relative;
          box-shadow:3px 9px 10px 0px rgba(15,15,15,0.15);
          &:hover{
            cursor: pointer;
            background: #4a98ff;
            transition-duration: 0.5s;
          }
          >img{
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
          }
          >span{
            width: 55px;
            height: 55px;
            display: block;
            text-align: center;
            font-size: 14px;
            color:white;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
          }
        }
        >div:nth-child(1){
          background: #e2b97d;
        }
        >div:nth-child(4){
          border-radius: 50%;
          box-shadow:3px 9px 10px 0px rgba(15,15,15,0.15);
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
  }
</style>
<style>
  .main > .el-container > .dia-title > .el-dialog >.el-dialog__header{
    height: 70px;
    line-height: 70px;
    background: #f9f9f9;
  }
  .main > .el-container > .dia-title > .el-dialog >.el-dialog__header > .el-dialog__title{
    color: #085ECC;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/tourist/common/MainContent.vue